export const ERROR_AUTHORIZATION_HEADER_EMPTY_IN_THE_REQUEST = 401;
export const ERROR_ACCESS_TOKEN_HAS_EXPIRED = 99001;
